import React from 'react';
import styled from '@emotion/styled';
import { tint } from 'polished';

import { Icon } from '../icons';

type Props = {
  className: ?string,
  href: string,
  icon?: string,
  children: React.Node,
  isHidden: boolean,
  onClick?: Function,
};

export const FloatingButton = ({ href, className, icon, children, isHidden, onClick }: Props) => {
  if (isHidden) return null;
  return (
    <FloatingButtonWrapper href={href} className={className} onClick={onClick}>
      {children && <CustomizeButtonText>{children}</CustomizeButtonText>}
      {icon && <Icon name={icon} />}
    </FloatingButtonWrapper>
  );
};

const FloatingButtonWrapper = styled('a')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  text-decoration: none;
  background-color: ${({ theme }) => tint(0.9, theme.color.brand)};
  border-radius: ${({ theme }) => theme.borderRadius.ellipse};
  border: ${({ theme }) => `2px solid ${theme.color.brand}`};
  color: ${({ theme }) => theme.color.brand};
  font-size: ${({ theme }) => theme.fontSize.md};
  box-shadow: ${({ theme }) => theme.boxShadow.medium};
  z-index: ${({ theme }) => theme.positioning.footer};
`;

const CustomizeButtonText = styled('span')`
  padding-right: 10px;
`;

FloatingButton.defaultProps = {
  className: null,
  isHidden: false,
  name: 'ChevronDown'
};
